
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23 0H1C.45 0 0 .45 0 1v16c0 .55.45 1 1 1h22c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM6.52 4.59c.68-.68 1.83-.8 2.64-.26.35.23.61.55.77.94a2.1 2.1 0 01-.45 2.28A2.072 2.072 0 018 8.16c-.27 0-.54-.05-.8-.16-.38-.16-.71-.43-.94-.77a2.105 2.105 0 01.26-2.64zM12.59 14H3.4c-.23 0-.42-.19-.42-.42 0-2.53 2.25-4.59 5.01-4.59S13 11.05 13 13.58c0 .23-.19.42-.42.42h.01zM19 14h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1zm0-4h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1zm0-4h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1z"}})])
          )
        }
      }
    